var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-bell",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconB-bell1",
    serifid: "iconB-bell"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.692,21.75c-0.413,-0.366 -0.453,-0.998 -0.088,-1.412c0.366,-0.414 0.998,-0.453 1.412,-0.088c0.529,0.467 1.223,0.75 1.984,0.75c0.761,0 1.455,-0.283 1.984,-0.75c0.414,-0.365 1.046,-0.326 1.411,0.088c0.366,0.414 0.326,1.046 -0.087,1.412c-0.882,0.778 -2.04,1.25 -3.308,1.25c-1.268,0 -2.426,-0.472 -3.308,-1.25Zm10.308,-13.75c-0,2.841 0.699,4.791 1.499,6.077c0.637,1.023 1.009,1.641 1.129,1.937c0.11,0.271 0.118,0.478 0.107,0.608c-0.044,0.547 -0.16,0.756 -0.601,1.083c-0.108,0.08 -0.279,0.175 -0.542,0.226c-0.287,0.056 -0.922,0.069 -1.981,0.069l-13.222,0c-1.059,0 -1.694,-0.013 -1.981,-0.069c-0.263,-0.051 -0.434,-0.146 -0.542,-0.226c-0.441,-0.327 -0.557,-0.536 -0.601,-1.083c-0.011,-0.13 -0.003,-0.337 0.107,-0.608c0.12,-0.296 0.492,-0.914 1.129,-1.937c0.8,-1.286 1.499,-3.236 1.499,-6.077c-0,-1.857 0.737,-3.637 2.05,-4.95c1.313,-1.313 3.093,-2.05 4.95,-2.05c1.856,0 3.637,0.737 4.95,2.05c1.313,1.313 2.05,3.093 2.05,4.95Zm-14.324,7.993c0.217,0.004 0.46,0.007 0.713,0.007l13.222,0c0.253,0 0.496,-0.003 0.713,-0.007c-0.151,-0.253 -0.33,-0.55 -0.523,-0.859c-0.941,-1.513 -1.801,-3.795 -1.801,-7.134c-0,-1.326 -0.527,-2.598 -1.464,-3.536c-0.938,-0.937 -2.21,-1.464 -3.536,-1.464c-1.326,-0 -2.598,0.527 -3.536,1.464c-0.937,0.938 -1.464,2.21 -1.464,3.536c-0,3.339 -0.86,5.621 -1.801,7.134c-0.193,0.309 -0.372,0.606 -0.523,0.859Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBBell);
export default __webpack_public_path__ + "static/media/iconB-bell.6292dfa90879778405f53a4aff084c39.svg";
export { ForwardRef as ReactComponent };